import { createHomeplanQuotesURL } from '@/src/constants/endpoints';
import { ApplianceType, GetQuotesOptions, GetQuotesResponse } from '../types';
import { createGetQuotesRequestBody } from './createGetQuotesRequestBody';
import { createGetQuotesRequestHeaders } from './createGetQuotesRequestHeaders';

export const getQuotes = async (
  needsRepair: boolean,
  isAbs?: boolean,
): Promise<GetQuotesResponse> => {
  const options: GetQuotesOptions = {
    applianceId: '1',
    applianceType: ApplianceType.GASBOILER,
    isHomeRecover: needsRepair,
    isAbs,
  };
  const body = createGetQuotesRequestBody(options);
  const headers = createGetQuotesRequestHeaders();

  try {
    const response = await fetch(createHomeplanQuotesURL(), {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });
    return (await response.json()) as GetQuotesResponse;
  } catch (error) {
    console.log('error', error);
    throw new Error(error as string);
  }
};
